import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-header" }, " Valor da sessão ")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Até 30 dias após as sessões serem realizadas é feito o repasse automático para a conta bancária. ", -1)
const _hoisted_5 = { class: "list-group list-group-flush" }
const _hoisted_6 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Valor total", -1)
const _hoisted_8 = {
  key: 0,
  class: "text-paragraph text-decoration-line-through me-2"
}
const _hoisted_9 = {
  key: 1,
  class: "text-paragraph"
}
const _hoisted_10 = {
  key: 0,
  class: "list-group-item d-flex justify-content-between align-items-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Código aplicado", -1)
const _hoisted_12 = { class: "text-subtitle" }
const _hoisted_13 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Benefício empresa", -1)
const _hoisted_15 = {
  key: 0,
  class: "list-group-item d-flex justify-content-between align-items-center"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Valor a receber", -1)
const _hoisted_17 = { class: "text-subtitle" }
const _hoisted_18 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Taxa Psiapp (20%)", -1)
const _hoisted_20 = { class: "text-paragraph" }
const _hoisted_21 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Valor a receber", -1)
const _hoisted_23 = { class: "text-subtitle" }
const _hoisted_24 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Repasse", -1)
const _hoisted_26 = {
  key: 0,
  class: "list-group-item d-flex justify-content-between align-items-center"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "Previsão de repasse", -1)
const _hoisted_28 = { class: "text-subtitle" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle mb-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-sack-dollar fa-lg me-1" }),
  /*#__PURE__*/_createTextVNode(" Visualizar repasse ")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right text-subtitle ms-auto" }, null, -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]

import type { Appointment } from "@phurshell/psiapp-frontend-core/domain";
import {
  EOffcanvasViews,
  OffcanvasViewsConfig,
  navigateCanvas,
} from "@/views/OffcanvasViews/OffcanvasViewsConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'Values',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;

function handlePayout() {
  const offcanvas_config = {
    ...OffcanvasViewsConfig.payout_detail,
    detail_id: props.item.payout!.payout_id,
  };
  navigateCanvas(EOffcanvasViews.payout_detail, offcanvas_config, false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", null, [
            (_ctx.item.coupon && _ctx.item.original_value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.item.original_value.toCurrency()), 1))
              : _createCommentVNode("", true),
            (_ctx.item.partnership)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.item.original_value.toCurrency()), 1))
              : (_ctx.item.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    class: _normalizeClass({
                'text-paragraph': _ctx.item.status === 'concluido' && _ctx.item.payout,
                'text-subtitle': !_ctx.item.payout || _ctx.item.status !== 'concluido',
              })
                  }, _toDisplayString(_ctx.item.value.toCurrency()), 3))
                : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.item.coupon)
          ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(`${_ctx.item.coupon.code} (${_ctx.item.coupon.percent_off}%)`), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.item.partnership)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("li", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", {
                  class: _normalizeClass(["text-paragraph", {
                'text-danger': !_ctx.item.payout || _ctx.item.status !== 'concluido',
              }])
                }, _toDisplayString(`-${(_ctx.item.original_value - _ctx.item.value).toCurrency()}`), 3)
              ]),
              (!_ctx.item.payout || _ctx.item.status !== 'concluido')
                ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.item.value.toCurrency()), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (
            _ctx.item.payout &&
            _ctx.item.payout.status !== 'pending' &&
            _ctx.item.status === 'concluido'
          )
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("li", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("span", _hoisted_20, "-" + _toDisplayString(_ctx.item.payout.fee.toCurrency()), 1)
              ]),
              _createElementVNode("li", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.item.payout.net.toCurrency()), 1)
              ]),
              _createElementVNode("li", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("span", {
                  class: "text-subtitle",
                  style: _normalizeStyle({
                color: _ctx.item.payout.status_config?.appointmentDetail?.color,
              })
                }, _toDisplayString(_ctx.item.payout.status_config?.appointmentDetail?.status), 5)
              ]),
              (_ctx.item.payout.main_payout_info?.arrival_date)
                ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.item.payout.formatted_arrival_date), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", { class: "list-group-item d-flex justify-content-between align-items-center" }, [
                _createElementVNode("div", {
                  class: "rounded-4 border p-4 d-flex align-items-center cursor-pointer w-100",
                  onClick: handlePayout
                }, _hoisted_31)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})